// export const formatDate = (date) => {
//     const day = date.getDate();
//     const month = date.getMonth() + 1;
//     return `${day}/${month}`;
// }

export function formatDate(value) {
    const [start, end] = value;
    
    const startDay = start.getDate();
    const startMonth = start.getMonth() + 1;

    const endDay = end.getDate();
    const endMonth = end.getMonth() + 1;
    
    return `${startDay}/${startMonth} - ${endDay}/${endMonth}`;
}